// @ts-nocheck
/**
 * NPCカード表示コンポーネント
 */

import React, { useState } from 'react';
import type { NpcDisplayInfo } from '../data/types';
import { starsToString } from '../data/constants';
import { getUnlockRequirementText } from '../systems/unlockChecker';
import {
  npcCardStyles as styles,
  getTierColor,
  STATUS_ICONS,
} from '../styles/adventureStyles';

interface NpcCardProps {
  npc: NpcDisplayInfo;
  onClick: () => void;
  isMobile?: boolean;
}

export const NpcCard: React.FC<NpcCardProps> = ({
  npc,
  onClick,
  isMobile = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const { status, record } = npc;
  const isLocked = status === 'locked';
  const isCleared = status === 'cleared';
  const isUnlocked = status === 'unlocked';

  // スタイルの組み合わせ
  const cardStyle = {
    ...styles.card,
    ...(isHovered && !isLocked ? styles.cardHover : {}),
    ...(isCleared ? styles.cardCleared : {}),
    ...(isUnlocked ? styles.cardUnlocked : {}),
    ...(isLocked ? styles.cardLocked : {}),
  };

  // ステータスバッジのスタイル
  const badgeStyle = {
    ...styles.statusBadge,
    ...(isCleared ? styles.statusCleared : {}),
    ...(isUnlocked ? styles.statusUnlocked : {}),
    ...(isLocked ? styles.statusLocked : {}),
  };

  // ステータスアイコン
  const statusIcon = STATUS_ICONS[status];

  // 戦績テキスト
  const recordText = record
    ? `${record.wins}勝 ${record.losses}敗`
    : '未挑戦';

  return (
    <div
      style={cardStyle}
      onClick={() => !isLocked && onClick()}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* ヘッダー部分 */}
      <div style={styles.header}>
        <div style={styles.portrait}>{npc.portrait}</div>
        <div style={styles.nameSection}>
          <h3 style={styles.name}>{npc.name}</h3>
          <div style={styles.deck}>{npc.deckName}</div>
        </div>
        <span style={badgeStyle}>
          {statusIcon}
        </span>
      </div>

      {/* 情報部分 */}
      <div style={styles.info}>
        <span
          style={{
            ...styles.difficulty,
            color: getTierColor(npc.tier),
          }}
        >
          {starsToString(npc.difficultyStars)}
        </span>

        {!isLocked && (
          <span style={styles.record}>
            戦績: {recordText}
          </span>
        )}
      </div>

      {/* 解放条件（ロック時のみ表示） */}
      {isLocked && (
        <div style={styles.unlockRequirement}>
          解放条件: {getUnlockRequirementText(npc.npcId)}
        </div>
      )}
    </div>
  );
};

export default NpcCard;
